import { defineStore } from 'pinia'

/** P0 曾用 sessionStorage；P2-1 改为纯内存，启动时清掉残留 */
const LEGACY_ACCESS_KEY = 'official_access_token'
const LEGACY_TOKEN_KEY = 'official_token'

function clearPersistedAccessResidue() {
  if (typeof sessionStorage !== 'undefined') {
    sessionStorage.removeItem(LEGACY_ACCESS_KEY)
  }
  if (typeof localStorage !== 'undefined') {
    localStorage.removeItem(LEGACY_TOKEN_KEY)
  }
}

export const useAuthStore = defineStore('auth', {
  state: () => ({
    /** Access 仅内存；F5 / 新标签须靠 Refresh Cookie 冷启动 */
    token: '',
    user: null,
    /** 冷启动（含无 Access 时试 refresh）是否完成 */
    authReady: false,
    _readyPromise: null,
  }),
  getters: {
    isLoggedIn: (s) => Boolean(s.token),
  },
  actions: {
    setSession(token, user) {
      this.token = token || ''
      if (user !== undefined) {
        this.user = user || null
      }
      clearPersistedAccessResidue()
    },

    setAccessToken(token) {
      this.setSession(token, this.user)
    },

    /**
     * @param {{ allowColdStart?: boolean }} [opts]
     * allowColdStart=true：清本地票但仍可能残留 Cookie，下次路由允许再试 refresh。
     * 默认 false：主动登出 / 必须重登后不再立刻冷启动 refresh（避免 logout 后多余 401）。
     */
    clear(opts = {}) {
      this.setSession('', null)
      this._readyPromise = null
      this.authReady = !opts.allowColdStart
    },

    /**
     * 冷启动：有内存 Access 直接就绪；无则试一次 refresh（Cookie）。
     * 路由守卫必须 await，避免误踢登录页。
     */
    ensureReady() {
      if (this.authReady) {
        return Promise.resolve()
      }
      if (this._readyPromise) {
        return this._readyPromise
      }
      this._readyPromise = (async () => {
        clearPersistedAccessResidue()
        try {
          if (this.token) {
            return
          }
          const { refreshAccessSingleFlight } = await import('../api/http')
          await refreshAccessSingleFlight()
        } catch {
          this.setSession('', null)
        } finally {
          this.authReady = true
          this._readyPromise = null
        }
      })()
      return this._readyPromise
    },
  },
})
